<template>
  <el-form label-width="200px">
    <el-form-item label="资讯标题：">
      <el-input
          style="width: 600px;"
          placeholder="请输入"
          v-model="formData.title"
      />
    </el-form-item>
    <el-form-item label="正文：">
      <my-edit v-model="formData.content"/>
    </el-form-item>

    <br>
    <el-form-item label="设置封面：">
      <more-img v-model="formData.coverImgs" type="2" :productId="this.informationId" :total="1" />
    </el-form-item>
  <!--  <el-form-item label="频道分类：">
      <el-select v-model="formData.tagsId" class="w300" clearable @change="tagChange">
        <el-option v-for="(item, index) in tagList" :key="index" :label="item.tagsName" :value="item.tagsId"/>
      </el-select>
    </el-form-item>
    <el-form-item label="标签：">
      <el-select v-model="formData.labelId" class="w300" multiple placeholder="请选择">
        <el-option
            v-for="item in labelList"
            :key="item.labelId"
            :label="item.labelName"
            :value="item.labelId">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="消息推送：">
      <el-radio v-model="formData.pushFlag" :label="true">是</el-radio>
      <el-radio v-model="formData.pushFlag" :label="false">否</el-radio>
    </el-form-item> -->
    <el-form-item class="mt55">
      <el-button @click="save(1)">取 消</el-button>
      <el-button @click="save(2)" type="primary">确 定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import {
    getYDProductDetail,
    yDProductDetailAddOrEdit,

    getInformationAuditMsg,
    getInformationClassify,
    getInformationTagsByClassify,
    setInformationMine
  } from '@/api'

  import MyEdit from '@/components/MyEdit'
  import MoreImg from '@/components/yDProductImg'

  export default {
    components: {MyEdit, MoreImg},
    props: {
      isEdit: Boolean,
      id: [String, Number]
    },
    watch: {
      id (nl, ol) {
        this.initFn()
      }
    },
    data () {
      return {
        formData: {
          title: '',
          context: '',
          tagsId: '',
          coverImgs: [],
          labelId: [],
          pushFlag: true
        },
        labelList: [],
        tagList: []
      }
    },
    computed: {
      informationId () {
        return this.id
      }
    },
    created () {
      this.initFn()
    },
    methods: {
      // 1关闭 2保存
      save (t) {
        if (t == 1) {
          this.$emit('close')
        } else {
          this.formData.ydProductId = this.informationId
          yDProductDetailAddOrEdit(this.formData).then(res => {
            this.$message.success(res.msg)
            this.$emit('close', 1)
          })
        }
      },
      initFn () {
        this.getInformationAuditMsgFn()
        //标签不加载
        //this.getInformationClassifyFn()
      },
      tagChange (val) {
        if (val) {
          this.formData.labelId = []
          this.labelList = []
          getInformationTagsByClassify(val).then(res => {
            this.labelList = res.data
          })
        }
      },
      getInformationAuditMsgFn () {
        getYDProductDetail({id:this.informationId}).then(res => {
          let temp = Object.assign({}, res.data)
          this.formData = {
            title: temp.title,
            content: temp.content,
            tagsId: temp.tagsId,
            coverImgs: [temp.cover] ,
            labelId: temp.labelIdList || [],
            pushFlag: true
          }
        })
      },
      getInformationClassifyFn () {
        getInformationClassify().then(res => {
          this.tagList = res.data
        })
      }
    }
  }
</script>

<style scoped>

</style>
